import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { theme } from 'components';
import ListingSection from './ListingSection';
import { ContentContainer } from './TaskLayout';

type AssignLockboxItemItemProps = {
  itemData: {
    listingId: string;
    line1: string;
    line2?: string;
    thumbnail?: string;
  };
};

const AssignLockboxItem: React.FC<AssignLockboxItemItemProps> = ({
  itemData,
}) => (
    <ContentContainer>
      <ListingSection listing={itemData} />
      <StyledLink
        to={`/listing/${itemData.listingId}/appointments/config`}
        data-cy={`add-config-${itemData.listingId}`}
      >
        Assign Lockbox
      </StyledLink>
    </ContentContainer>
  );

export default AssignLockboxItem;

const StyledLink = styled(Link)`
  display: flex;
  color: ${theme.blueBase};
  font-size: 14px;
  line-height: 1.375rem;
  margin-top: 10px;
`;
